import Component from "vue-class-component";
import {Vue} from "vue-property-decorator";
import {namespace} from "vuex-class";

import { Setting } from "@/model/menuSetting";
import Table from "@/model/table";

const tableStore = namespace("TableStore")
const menuStore = namespace("MenuStore")

@Component
class AllYouCanEatDrink extends Vue {
  @tableStore.Getter
  getTable!: Table;
  @menuStore.Getter
  getMenuSetting!: Setting;
  get isActiveAllYouCanDrink(): boolean {
    return this.getTable?.tables[0]?.TBL_DFREE == "1";
  }

  get isActiveAllYouCanEat(): boolean {
    return this.getTable?.tables[0]?.TBL_FREE == "1";
  }

  public isFreeMenu(menu: {allYouCanEat: boolean, foodKind: string}): boolean
  {
    const setting = this.getMenuSetting;

    if (!(this.isActiveAllYouCanDrink || this.isActiveAllYouCanEat)) {
      return false;
    }
    if (menu.allYouCanEat && setting.allYouCanEatKbn[menu.foodKind]) {
      return true;
    }

    return false;
  }

  public getPriceFormat(price): string {
    if ( price === 0 ) {
      return "0"
    } else {
      return price.toLocaleString('ja-JP');
    }
  }

  public displayMenuPrice(menu): string
  {
    const setting = this.getMenuSetting;

    if (!(this.isActiveAllYouCanDrink || this.isActiveAllYouCanEat)) {
      return this.getPriceFormat(menu.price) + this.$t('円');
    }
    if (menu.allYouCanEat && setting.allYouCanEatKbn[menu.foodKind]) {
      return "" // don't display the price
    }

    return this.getPriceFormat(menu.price) + this.$t('円');
  }
}

export default AllYouCanEatDrink;
